import remark from 'remark'
import strip from 'strip-markdown'

const stripMarkdown = (md) => {
  if (!md) return md

  return remark()
    .use(strip)
    .processSync(md)
    .toString()
    .trimEnd()
    .replace(/(\r\n|\n|\r)/gm, ' ')
    .replace(/ +(?= )/g, '')
}

export default stripMarkdown
